<style lang="stylus">
    .ft-aigray-text
        width 100%
        height 32px
        display flex
        align-items center
        p
            padding-left 10px
            font-size 12px
            color var(--text-color-primary-70)
        &.ft-h-divided
            border-top 1px solid var(--border-color-box-6)
</style>

<template>
    <div v-if="!internal && !isEchartItem">
        <div v-if="showSubtitle" class="ft-aigray-text">
            <p>{{ $t("diagramAnalysis") }}</p>
        </div>
        <FtMenu :imgIcon="'ai-diagram-selected'" :text="$t('selectedPart')" @clickMenu="clickMenu('diagram-selected')" :placement="placement" />
        <FtMenu :imgIcon="'ai-diagram-page'" :text="$t('currentPage')" @clickMenu="clickMenu('diagram-page')" :placement="placement" />
    </div>
</template>

<script lang="ts">
    import { Component, Prop } from "vue-property-decorator";
    import AiSocket from "@/app/mixin/aiSocket";
    import FtIcon from "./public/FtIcon.vue";
    import FtMenu from "./public/FtMenu.vue";

    @Component({
        components: {
            FtIcon,
            FtMenu,
        },
    })
    export default class AiContent extends AiSocket {
        @Prop({ default: true })
        showSubtitle;

        @Prop({ default: "floatMenu" }) // floatMenu、rightClickMenu
        fromType;

        get placement() {
            return this.fromType === "rightClickMenu" ? "right" : "left";
        }
        get isEchartItem() {
            return this.$store.state.shape.type == "EChartItem";
        }

        clickMenu(str) {
            this.diagramAnalysisHandler(str);

            if (this.fromType === "rightClickMenu") {
                this.$store.commit("closeContext");
            }
        }
    }
</script>
<i18n>
{
  "zh": {
    "diagramAnalysis": "图片分析",
    "selectedPart": "分析选择的部分",
    "currentPage": "分析当前页面"
  },
  "en": {
    "diagramAnalysis": "Picture Analysis",
    "selectedPart": "Analyze the selected part",
    "currentPage": "Analyze the current page"
  },
  "fr": {
    "diagramAnalysis": "Analyse d'image",
    "selectedPart": "Analysez la partie sélectionnée",
    "currentPage": "Analysez la page actuelle"
  },
  "de": {
    "diagramAnalysis": "Bildanalyse",
    "selectedPart": "Analysieren Sie den ausgewählten Teil",
    "currentPage": "Analysieren Sie die aktuelle Seite"
  },
  "jp": {
    "diagramAnalysis": "画像解析",
    "selectedPart": "選択した部分を分析する",
    "currentPage": "現在のページを分析する"
  },
  "es": {
    "diagramAnalysis": "Análisis de imágenes",
    "selectedPart": "Analiza la parte seleccionada",
    "currentPage": "Analiza la página actual"
  },
  "pt": {
    "diagramAnalysis": "Análise de imagem",
    "selectedPart": "Analise a parte selecionada",
    "currentPage": "Analise a página atual"
  },
  "it": {
    "diagramAnalysis": "Analisi immagine",
    "selectedPart": "Analizza la parte selezionata",
    "currentPage": "Analizza la pagina corrente"
  },
  "tw": {
    "diagramAnalysis": "圖片分析",
    "selectedPart": "分析選擇的部分",
    "currentPage": "分析當前頁面"
  },
  "kr": {
    "diagramAnalysis": "사진 분석",
    "selectedPart": "선택한 부분을 분석하십시오",
    "currentPage": "현재 페이지를 분석하십시오"
  }
}
</i18n>
